/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Status { 
    fullNumber?: string;
    personalNote?: string;
    outOfOfficeNote?: string;
    location?: string;
    presenceAvailability?: Status.PresenceAvailabilityEnum;
    presenceActivity?: Status.PresenceActivityEnum;
    meetingSubject?: string;
    meetingLocation?: string;
}
export namespace Status {
    export type PresenceAvailabilityEnum = 'None' | 'Online' | 'IdleOnline' | 'Busy' | 'IdleBusy' | 'DoNotDisturb' | 'BeRightBack' | 'Away' | 'Offline';
    export const PresenceAvailabilityEnum = {
        None: 'None' as PresenceAvailabilityEnum,
        Online: 'Online' as PresenceAvailabilityEnum,
        IdleOnline: 'IdleOnline' as PresenceAvailabilityEnum,
        Busy: 'Busy' as PresenceAvailabilityEnum,
        IdleBusy: 'IdleBusy' as PresenceAvailabilityEnum,
        DoNotDisturb: 'DoNotDisturb' as PresenceAvailabilityEnum,
        BeRightBack: 'BeRightBack' as PresenceAvailabilityEnum,
        Away: 'Away' as PresenceAvailabilityEnum,
        Offline: 'Offline' as PresenceAvailabilityEnum
    };
    export type PresenceActivityEnum = 'None' | 'Meeting' | 'OnThePhone';
    export const PresenceActivityEnum = {
        None: 'None' as PresenceActivityEnum,
        Meeting: 'Meeting' as PresenceActivityEnum,
        OnThePhone: 'OnThePhone' as PresenceActivityEnum
    };
}
